import React, { useState } from 'react';
import './PillToggle.css';

export default function PillToggle({ onChange, offLabel, onLabel, initialValue = false }) {
  const [isOn, setIsOn] = useState(initialValue);

  const handleToggle = () => {
    const nextState = !isOn;
    setIsOn(nextState);
    if (onChange) onChange(nextState);
  };

  const hasLabels = offLabel || onLabel;

  return (
    <div className="pill-toggle-container">
      <button
        type="button"
        className={`pill-track ${isOn ? 'on' : 'off'}${hasLabels ? ' pill-with-labels' : ''}`}
        onClick={handleToggle}
        aria-pressed={isOn}
        aria-label={isOn ? onLabel || 'Toggle on' : offLabel || 'Toggle off'}
      >
        {offLabel && <span className="pill-label pill-label-left">{offLabel}</span>}
        <div className="pill-thumb" />
        {onLabel && <span className="pill-label pill-label-right">{onLabel}</span>}
      </button>
    </div>
  );
}
